var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      短信通知："),
            _c("el-switch", {
              attrs: {
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.settingsChange($event, "smsFlag")
                }
              },
              model: {
                value: _vm.settingsConfig.smsFlag,
                callback: function($$v) {
                  _vm.$set(_vm.settingsConfig, "smsFlag", $$v)
                },
                expression: "settingsConfig.smsFlag"
              }
            })
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，签约、审批等信息将通过短信通知您（若企业人脸识别授权列表中仅有法人，则将发送给法人，若人脸识别授权列表存在授权人，则将发送给默认授权人）。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      邮件通知：\n      "),
            _c("el-switch", {
              attrs: {
                value: _vm.settingsConfig.emailFlag,
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.bindEmailSwitchChange($event, "emailFlag")
                }
              }
            }),
            _vm.settingsConfig.email
              ? [
                  _c("span", { staticClass: "bind-target" }, [
                    _vm._v("已绑定：" + _vm._s(_vm.settingsConfig.email))
                  ]),
                  _c(
                    "span",
                    { staticClass: "unbind", on: { click: _vm.emailEditFn } },
                    [_vm._v("修改")]
                  )
                ]
              : _vm._e()
          ],
          2
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，签约、审批等信息将通过邮件通知您（邮件将发送至企业账号对应的邮箱）。"
          )
        ])
      ]),
      _c("div", { staticClass: "box-card" }, [
        _c(
          "p",
          [
            _vm._v("\n      微信通知：\n      "),
            _c("el-switch", {
              attrs: {
                value: _vm.settingsConfig.wxFlag,
                "active-color": _vm.activeColor,
                "active-value": _vm.activeVal,
                "inactive-value": _vm.inactiveVal
              },
              on: {
                change: function($event) {
                  return _vm.weChatSwitchChange($event, "wxFlag")
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.settingsConfig.wxName,
                    expression: "settingsConfig.wxName"
                  }
                ]
              },
              [
                _c("span", { staticClass: "bind-target" }, [
                  _vm._v("已绑定：" + _vm._s(_vm.settingsConfig.wxName))
                ]),
                _c(
                  "span",
                  {
                    staticClass: "unbind",
                    attrs: { slot: "reference" },
                    on: { click: _vm.unnindWx },
                    slot: "reference"
                  },
                  [_vm._v("解绑")]
                )
              ]
            )
          ],
          1
        ),
        _c("span", [
          _vm._v(
            "提示：开启时，签约、审批等信息将通过微信消息通知您（签署通知将发送至当前账号绑定的微信账号，一个账号仅能绑定一个微信）。"
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定微信",
            visible: _vm.bindWeChatVisi,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.bindWeChatVisi = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "qrcode-box" },
            [
              _c("qrcode", {
                key: "evidence",
                attrs: { value: _vm.bindWechatQR.url, size: 260, leave: "H" }
              }),
              _c("p", [_vm._v("使用手机微信扫码绑定")])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.bindWeChatVisi = false
                    }
                  }
                },
                [_vm._v("关 闭")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定邮箱",
            visible: _vm.bindEmailVisi,
            width: "50%",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.bindEmailVisi = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "bingEmailRef",
              attrs: {
                model: _vm.bingEmailForm,
                rules: _vm.bindEmailRules,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "邮箱：", prop: "email" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.bingEmailForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.bingEmailForm, "email", $$v)
                      },
                      expression: "bingEmailForm.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "验证码：", prop: "valicode" } },
                [
                  _c(
                    "el-input",
                    {
                      model: {
                        value: _vm.bingEmailForm.valicode,
                        callback: function($$v) {
                          _vm.$set(_vm.bingEmailForm, "valicode", $$v)
                        },
                        expression: "bingEmailForm.valicode"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "append",
                            type: "primary",
                            disabled: _vm.emailCodeCountdown > 0
                          },
                          on: { click: _vm.sendVaild },
                          slot: "append"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.emailCodeCountdown > 0
                                ? _vm.emailCodeCountdown + "S"
                                : "发送验证码"
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.bindnotifyEmail }
                },
                [_vm._v("绑 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ]
        },
        [
          _c(
            "ali-captcha",
            {
              attrs: {
                handCallback: _vm.countdownLe,
                targetId: _vm.bingEmailForm.email,
                verifyType: _vm.BUSITYPE.OTHER
              }
            },
            [_c("button", { ref: "aliCaptchaRef" }, [_vm._v("发送验证码")])]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.PersonchangeEmailVisi,
            "show-close": false,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.PersonchangeEmailVisi = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "personChangeEmailRef",
              staticClass: "user-form-sty",
              attrs: {
                "label-width": "120px",
                size: "small",
                model: _vm.PersonAccount,
                rules: _vm.accountRules
              }
            },
            [
              _c("el-form-item", { attrs: { label: "原邮箱：" } }, [
                _c(
                  "div",
                  { staticClass: "item-box" },
                  [
                    _c("el-input", {
                      attrs: { value: _vm.settingsConfig.email, disabled: "" }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "验证码：", prop: "valicode" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { maxLength: 4, placeholder: "请输入验证码" },
                          model: {
                            value: _vm.PersonAccount.valicode,
                            callback: function($$v) {
                              _vm.$set(_vm.PersonAccount, "valicode", $$v)
                            },
                            expression: "PersonAccount.valicode"
                          }
                        },
                        [
                          _c("template", { slot: "append" }, [
                            _c(
                              "span",
                              {
                                staticClass: "img-code",
                                on: { click: _vm.getImgCode }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "data:image/png;base64," +
                                      _vm.imgCodeData.imgPath
                                  }
                                })
                              ]
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "新邮箱：", prop: "email" } },
                [
                  _c(
                    "div",
                    { staticClass: "item-box" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入新邮箱" },
                        model: {
                          value: _vm.PersonAccount.email,
                          callback: function($$v) {
                            _vm.$set(_vm.PersonAccount, "email", $$v)
                          },
                          expression: "PersonAccount.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c("span", { staticStyle: { color: "#ec1c1c" } }, [
                    _vm._v("注：请在新邮箱中点击链接激活邮箱换绑")
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.PersonchangeEmailVisi = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.unbindEmailOfPerson }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("消息通知设置")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05b9fd19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b9fd19","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/components/msgNotifi.vue
// module id = XcLD
// module chunks = 93 165